module.exports = __webpack_public_path__ + "static/media/GMT20200622-223024_Andrew-Coh_1440x900.ba8267d9.mp4";